import { connect } from 'react-redux';
import {
	GetCommissionCount,
	GetCommissions,
	GetSalesPersonRecordCount,
	LoadSalespersonPendingCommissions,
} from './actions';
import Commissions from './index';

const mapStateToProps = (state) => {
	return {
		user: state.auth.user,
		records: state.commissions.commissions,
		recordCount: state.commissions.count,
		isMaster: state.auth.isMaster,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getRecords: (searchObject, page, pageSize) => dispatch(GetCommissions(searchObject, page, pageSize)),
		getRecordCount: () => dispatch(GetCommissionCount()),
		getSalespersonRecords: (salesPersonId, page = 1, pageSize = 10) =>
			dispatch(LoadSalespersonPendingCommissions(salesPersonId, page, pageSize)),
		getSalesPersonRecordCount: (salesPersonId) => dispatch(GetSalesPersonRecordCount(salesPersonId)),
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(Commissions);
